<template>
  <!-- 模板文件管理 -->
  <el-button-group>
    <el-button type="primary" size="large" @click="addFnc($event)"
      ><el-icon><Plus /></el-icon>添加模板文件</el-button
    >
    <!-- <el-button type="primary" size="large" plain @click="recoverFnc($event)"
      ><el-icon><Refresh /></el-icon>恢复模板</el-button
    >
    <el-button type="primary" size="large" plain @click="publishFnc($event)"
      ><el-icon><Position /></el-icon>发布模板</el-button
    > -->
  </el-button-group>

  <!-- 表格组件 -->
  <TableList
    componentTableId="TemplateFileManagement"
    @update-list="updateList"
    excelName="模板文件管理"
    :table-data="tableData"
    :header-data="headerData"
    :table-height="tableMaxHeight"
    :loading="loading"
    :loading-text="loadingText"
    :empty-text="emptyText"
    @editFnc="editFnc"
    @deleteFnc="deleteFnc"
    @searchFnc="searchFnc"
    @handleSelection="handleSelection"
    @openContent="openContent"
  >
  </TableList>
  <!-- 模板内容 -->
  <el-dialog
    v-model="contentVisible"
    :title="contentdialogTitle"
    width="1200px"
  >
    <div class="contentDialog" v-html="contentDetails"></div>
  </el-dialog>
  <!-- 添加编辑 模板文件管理 -->
  <el-dialog
    class="dialogNoPadding"
    :close-on-click-modal="false"
    v-model="addEditVisible"
    :title="dialogTitle"
    width="800px"
  >
    <AddEditTemplateFile
      v-if="addEditVisible"
      :edit-id="editId"
      @close-dialog="closeDialog"
      @update-list="updateList"
    ></AddEditTemplateFile>
  </el-dialog>
</template>

<script>
import TableList from "components/TableList.vue";
import { reactive, onMounted, toRefs, computed, toRaw } from "vue";
import { ElMessage, ElMessageBox } from "element-plus";
import { lostFocus } from "common/utils";
import {
  getTemplate,
  getAllClasses,
  deleteTemplate,
  revertTemplate,
  publishTemplate,
} from "network/templateFile.js";
import AddEditTemplateFile from "views/templateFileManagement/AddEditTemplateFile.vue";
import store from "../../store/index";
export default {
  name: "TemplateFileManagement",
  props: {
    tableMaxHeight: Number,
  },
  components: {
    TableList,
    AddEditTemplateFile,
  },
  setup() {
    //这里定义一个结构体，用来保存项目信息
    const data = reactive({
      // 表格是否在加载中
      loading: true,
      loadingText: "加载中...",
      emptyText: "暂无数据",

      tableData: [],
      headerData: [
        {
          label: "勾选框",
          type: "selection",
          width: "55",
          fixed: "left",
        },{
          label: "标题名称",
          prop: "title",
          width: "200",
          align: "left",
          noSetText: "未设置",
          type: "InputSearch",
          fixed: "left",
        },
        {
          label: "模板文件类型",
          prop: "className",
          width: "220",
          align: "center",
          noSetText: "未设置",
          type: "SelectSearch",
          selectOptions: [],
        },
        {
          label: "模板内容",
          prop: "content",
          width: "220",
          align: "center",
          noSetText: "未设置",
          isToMoreContents: true,
        },
        {
          label: "创建人",
          prop: "creater",
          width: "220",
          align: "center",
          noSetText: "未设置",
        },
        {
          label: "创建时间",
          prop: "createTime",
          width: "220",
          align: "center",
          noSetText: "未设置",
        },
        {
          label: "操作",
          prop: "operation",
          width: "200",
          align: "center",
          fixed: "right",
          operation: true,
          edit: true,
          delete: true,
        },
      ],
      title: "", //筛选 模板文件名称
      class: null,
      dialogTitle: "添加模板文件",
      addEditVisible: false, //添加编辑弹窗
      editId: 0, //是否是编辑
      multipleSelection: [],
      allClasses: [], // 全部类型
      contentdialogTitle: "查看模板内容",
      contentVisible: false, //模板内容弹窗
      contentDetails: "", //模板内容
      adminCache: store.state.AdminCache, //登陆人
    });
    //挂载后调用函数获取项目数据
    onMounted(() => {
      getListData(); //请求模板文件列表数据
      getClasses(); //获取全部模板文件类别
    });
    const getClasses = () => {
      getAllClasses().then((res) => {
        if (res && res.code == 1) {
          data.allClasses = res.result;
          data.headerData.map((item) => {
            if (item.prop == "className") {
              item.selectOptions = data.allClasses;
            }
          });
        } else {
        }
      });
    };
    // 获取列表
    const getListData = () => {
      data.loading = true;
      const obj = {
        title: data.title || null,
        class: data.class,
      };
      getTemplate(obj)
        .then((result) => {
          if (result && result.code == 1) {
            data.tableData = result.result;
            data.tableData.forEach((item) => {
              if (item.creater == data.adminCache.id) {
                item.creater = data.adminCache.name;
              }
            });
            data.loading = false;
          } else {
            data.loading = false;
            ElMessage.error(result.message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    };

    // 搜索
    const searchFnc = (val) => {
      if (val.prop && val.prop == "title") {
        data.title = val.value;
      }
      if (val.prop && val.prop == "className") {
        data.class = val.value;
      }
      getListData();
    };

    //更新列表
    const updateList = () => {
      getListData();
    };

    //关闭弹窗
    const closeDialog = () => {
      data.addEditVisible = false;
    };

    // 添加
    const addFnc = (e) => {
      // 强制移除按钮焦点
      lostFocus(e);
      data.addEditVisible = true;
      data.dialogTitle = "添加模板文件";
      data.editId = 0;
    };

    // 编辑模板文件
    const editFnc = (obj) => {
      data.addEditVisible = true;
      data.dialogTitle = `编辑【${obj.title}】模板文件`;
      data.editId = obj.id;
    };

    // 删除
    const deleteFnc = (obj) => {
      ElMessageBox.confirm(`是否删除[${obj.title}]】模板文件`, "删除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteData(obj.id);
        })
        .catch(() => {
          ElMessage("取消删除");
        });
    };
    function deleteData(id) {
      deleteTemplate(id)
        .then((result) => {
          if (result && result.code == 1) {
            ElMessage.success(result.message);
            updateList();
          } else {
            ElMessage.error(result.message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }

    // 表格多选行处理
    const handleSelection = (row) => {
      data.multipleSelection = JSON.parse(JSON.stringify(row));
    };

    //查看详情弹窗
    const openContent = (val) => {
      if (val.prop == "content") {
        data.contentdialogTitle = `查看【${val.value.title}】模板内容`;
        data.contentVisible = true;
        // 需要把{{P-1}} 替换成P-1C，{{P-2}}替换成P-2C
        let sitePcWebUrl =store.state.AdminInfo.sitePcWebUrl || sessionStorage.getItem("AdminInfo").sitePcWebUrl;
      //  let replace = [{ id: "#SitePcWebUrl", value: sitePcWebUrl }];
        // 通过构造函数创建的正则表达式可以使用变量
        // for (let i = 0; replace.length; i++) {
          let reg = new RegExp("{{#SitePcWebUrl}}");
          val.value.content = val.value.content.replace(reg,sitePcWebUrl);
        // }
        data.contentDetails = val.value.content;
      }
    };

    //恢复
    const recoverFnc = (e) => {
      // 强制移除按钮焦点
      lostFocus(e);
      if (data.multipleSelection.length == 0) {
        ElMessage.warning("请先选择一个需要恢复的模板文件");
      }
      if (data.multipleSelection.length == 1) {
        ElMessageBox.confirm(
          `确认恢复[${data.multipleSelection[0].title}]模板文件吗？`,
          "删除",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        )
          .then(() => {
            let id = data.multipleSelection[0].id;
            revertTemplate(id)
              .then((result) => {
                if (result && result.code == 1) {
                  ElMessageBox.alert(result.message, "恢复", {
                    confirmButtonText: "确定",
                    callback: (action) => {},
                  });
                  updateList();
                } else {
                  ElMessage.error(result.message);
                }
              })
              .catch((err) => {
                console.log(err);
              });
          })
          .catch(() => {
            ElMessage("取消恢复");
          });
      }
      if (data.multipleSelection.length > 1) {
        ElMessage.warning("单次只能选择一个模板文件进行操作");
      }
    };
    //发布
    const publishFnc = (e) => {
      // 强制移除按钮焦点
      lostFocus(e);
      if (data.multipleSelection.length == 0) {
        ElMessage.warning("请先选择一个需要发布的模板文件");
      }
      if (data.multipleSelection.length == 1) {
        ElMessageBox.confirm(
          `确认发布[${data.multipleSelection[0].title}]模板文件吗？`,
          "发布",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        )
          .then(() => {
            let id = data.multipleSelection[0].id;
            publishTemplate(id)
              .then((result) => {
                if (result && result.code == 1) {
                  ElMessageBox.alert(result.message, "发布 ", {
                    confirmButtonText: "确定",
                    callback: (action) => {},
                  });
                  updateList();
                } else {
                  ElMessage.error(result.message);
                }
              })
              .catch((err) => {
                console.log(err);
              });
          })
          .catch(() => {
            ElMessage("取消发布");
          });
      }
      if (data.multipleSelection.length > 1) {
        ElMessage.warning("单次只能选择一个模板文件进行操作");
      }
    };

    return {
      //解构Data结构体，让模板可以直接调用Data里面的对象
      ...toRefs(data),
      getListData,
      searchFnc,
      updateList,
      closeDialog,
      addFnc,
      editFnc,
      deleteFnc,
      handleSelection,
      openContent,
      recoverFnc,
      publishFnc,
    };
  },
};
</script>
<style scoped>
</style>

